/**
 * Attaches the logged-in user's session id to raw XMLHttpRequest calls.
 *
 * Most API traffic goes through:
 *   - Angular HttpClient -> UserTokenInterceptor   (handles `setHeaders`)
 *   - jQuery $.ajax / DataTables -> ajaxPrefilter   (set in AppComponent.ngOnInit)
 *
 * A handful of components (reports XLSX downloads, CKEditor image upload)
 * use a raw `new XMLHttpRequest()` because they need direct control over
 * `responseType = 'blob'` or progress events. Those call this helper
 * immediately after `xhr.open(...)` so the request still authenticates.
 *
 * Scope: only attaches the header for URLs hitting our backend (/api/...).
 * Prevents accidentally leaking the session id to a third-party URL.
 */
export function attachUserToken(xhr: XMLHttpRequest, url: string): void {
  if (!/\/api(\/|$|\?)/.test(url)) {
    return;
  }
  const uid = localStorage.getItem('loggedInMbId');
  if (uid) {
    xhr.setRequestHeader('X-User-Token-Id', uid);
  }
}
